<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="dismiss()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">{{ inspeccion.direccion || 'Inspección' }}</div>
          <div class="title-sub">{{ inspeccion.cliente || 'Ítems de la Solicitud' }}</div>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="light-bg ion-padding fade-in">

    <!-- ── Barra Compacta de Acciones Rápidas ──────────────────────────── -->
    <div class="quick-actions-bar">

      <!-- Eliminar Inspección -->
      <button class="qa-chip qa-danger"
        *ngIf="permissions.inspeccion?.eliminar_inspeccion !== false"
        (click)="deleteInspeccion()">
        <ion-icon name="trash-outline"></ion-icon>
        <span>Eliminar</span>
      </button>

      <!-- Cotización: Sin vincular -->
      <ng-container *ngIf="!loadingCotizacion && !linkedCotizacion && permissions.inspeccion?.vincular_cotizacion">
        <button class="qa-chip qa-default" (click)="vincularExistente()">
          <ion-icon name="link-outline"></ion-icon>
          <span>Vincular</span>
        </button>
        <button class="qa-chip qa-success" (click)="crearNueva()">
          <ion-icon name="add-circle-outline"></ion-icon>
          <span>Crear Cot.</span>
        </button>
      </ng-container>

      <!-- Cotización: Vinculada -->
      <ng-container *ngIf="!loadingCotizacion && linkedCotizacion as cot">
        <button class="qa-chip qa-linked"
          [class.no-click]="!permissions.inspeccion?.vincular_cotizacion"
          (click)="permissions.inspeccion?.vincular_cotizacion ? irACotizacion() : null">
          <ion-icon name="receipt-outline"></ion-icon>
          <span>Cot. #{{ cot.id }}</span>
          <span class="qa-amount">{{ cot.total | currency:'USD':'symbol':'1.0-0' }}</span>
          <ion-icon name="chevron-forward-outline" style="font-size: 0.7rem; opacity: 0.6;"></ion-icon>
        </button>
        <button class="qa-chip qa-danger-soft"
          *ngIf="permissions.inspeccion?.vincular_cotizacion"
          (click)="desvincular()">
          <ion-icon name="unlink-outline"></ion-icon>
        </button>
      </ng-container>

      <!-- Spinner de carga de cotización -->
      <div class="qa-chip qa-loading" *ngIf="loadingCotizacion">
        <ion-spinner name="crescent" style="width: 14px; height: 14px;"></ion-spinner>
        <span>Cargando...</span>
      </div>

    </div>

    <!-- Cabecera de Sección con Segment de Vista -->
    <div class="view-segment-wrapper" style="margin-top: 12px; margin-bottom: 8px;">
      <div class="section-label" style="margin: 0;">Ítems Inspeccionados</div>
      <div class="view-segment">
        <button class="seg-btn" [class.active]="viewMode === 'list'" (click)="setViewMode('list')">
          <ion-icon name="list-outline"></ion-icon>
          <span>Lista</span>
        </button>
        <button class="seg-btn" [class.active]="viewMode === 'card'" (click)="setViewMode('card')">
          <ion-icon name="albums-outline"></ion-icon>
          <span>Tarjeta</span>
        </button>
      </div>
    </div>

    <!-- ════════════ VISTA LISTA DE ÍTEMS ════════════ -->
    <div class="list-wrapper" *ngIf="viewMode === 'list'">
      <div *ngFor="let item of displayedDetalles" class="premium-card area-item-card" (click)="openDatos(item)">
        <div class="area-icon-box">
          <ion-icon name="document-text-outline"></ion-icon>
        </div>
        <div class="area-content-main">
          <div class="area-title">{{ item.comentario || item.area || 'Ítem sin descripción' }}</div>
          <div class="area-subtitle" *ngIf="item.area || item.estructura">
            <span *ngIf="item.area">🏷️ {{ item.area }}</span>
            <span *ngIf="item.estructura"> · 🏗️ {{ item.estructura }}</span>
          </div>
        </div>
        <div class="area-actions-end">
          <ion-button fill="clear" (click)="viewItemDetail(item); $event.stopPropagation()">
            <ion-icon name="information-circle-outline" slot="icon-only" color="primary"></ion-icon>
          </ion-button>
          <ion-button fill="clear" (click)="editDetalle(item); $event.stopPropagation()">
            <ion-icon name="create-outline" slot="icon-only" color="medium"></ion-icon>
          </ion-button>
        </div>
      </div>

      <div class="empty-state-container" *ngIf="displayedDetalles.length === 0">
        <ion-icon name="layers-outline"></ion-icon>
        <p>No hay ítems registrados para esta inspección</p>
      </div>

      <ion-infinite-scroll (ionInfinite)="loadData($event)">
        <ion-infinite-scroll-content loadingSpinner="crescent"></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </div>

    <!-- ════════════ VISTA CARD DE ÍTEMS (UNO POR PANTALLA) ════════════ -->
    <div class="card-view-area" *ngIf="viewMode === 'card'" style="background: transparent; padding: 0;">

      <!-- Sin resultados -->
      <div class="empty-state card-empty" *ngIf="displayedDetalles.length === 0">
        <ion-icon name="layers-outline"></ion-icon>
        <p>No hay ítems registrados</p>
      </div>

      <!-- Indicador de posición -->
      <div class="card-position-bar" *ngIf="displayedDetalles.length > 0" style="margin-bottom: 4px;">
        <span class="pos-current">{{ currentCardIndex + 1 }}</span>
        <span class="pos-sep">/</span>
        <span class="pos-total">{{ displayedDetalles.length }}</span>
      </div>

      <!-- Tarjeta principal -->
      <div class="big-card-wrapper" *ngIf="displayedDetalles.length > 0"
        (touchstart)="onCardTouchStart($event)"
        (touchend)="onCardTouchEnd($event)">

        <div class="big-card" *ngIf="currentCard" 
          [class.slide-in-left]="cardAnimation === 'left'" 
          [class.slide-in-right]="cardAnimation === 'right'"
          data-estado="en-proceso"
          style="border-left-color: #3498db; min-height: 220px;">

          <!-- Header del ítem -->
          <div class="bc-header">
            <div class="bc-avatar bc-avatar-en-proceso">
              <span>{{ ((currentCard.comentario || currentCard.area || 'I').charAt(0)) | uppercase }}</span>
            </div>
            <div class="bc-header-info">
              <div class="bc-cliente-row">
                <span class="bc-cliente">{{ currentCard.comentario || currentCard.area || 'Ítem sin descripción' }}</span>
              </div>
              <div class="bc-estado en-proceso" (click)="openDatos(currentCard)">
                <ion-icon name="clipboard-outline" style="font-size: 11px; margin-right: 2px;"></ion-icon>
                REGISTROS
              </div>
            </div>
          </div>

          <div class="bc-divider"></div>

          <!-- Detalles de Categorización (Áreas y Estructuras) -->
          <div class="bc-details">
            <div class="bc-detail-row" *ngIf="currentCard.area">
              <div class="bc-detail-icon person" style="background: rgba(52, 152, 219, 0.1); color: #3498db;">
                <ion-icon name="map-outline"></ion-icon>
              </div>
              <div class="bc-detail-info">
                <span class="bc-detail-label">Áreas Categorizadas</span>
                <span class="bc-detail-value">{{ currentCard.area }}</span>
              </div>
            </div>

            <div class="bc-detail-row" *ngIf="currentCard.estructura">
              <div class="bc-detail-icon person" style="background: rgba(155, 89, 182, 0.1); color: #9b59b6;">
                <ion-icon name="construct-outline"></ion-icon>
              </div>
              <div class="bc-detail-info">
                <span class="bc-detail-label">Estructuras</span>
                <span class="bc-detail-value">{{ currentCard.estructura }}</span>
              </div>
            </div>
          </div>

          <!-- Botones de Acción -->
          <div class="bc-actions">
            <button class="bc-action-btn secondary" (click)="editDetalle(currentCard)">
              <ion-icon name="create-outline"></ion-icon>
              <span>Editar</span>
            </button>
            <button class="bc-action-btn primary" (click)="openDatos(currentCard)">
              <ion-icon name="clipboard-outline"></ion-icon>
              <span>Registros</span>
            </button>
            <button class="bc-action-btn secondary" (click)="deleteArea(currentCard)" style="flex: 0 0 44px; color: #e74c3c; background: rgba(231, 76, 60, 0.08);">
              <ion-icon name="trash-outline"></ion-icon>
            </button>
          </div>

        </div>
      </div>

      <!-- Navegación entre tarjetas -->
      <div class="card-nav" *ngIf="displayedDetalles.length > 1" style="padding-bottom: 0;">
        <button class="nav-btn" (click)="prevCard()" [disabled]="currentCardIndex === 0">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </button>

        <div class="nav-dots">
          <span *ngFor="let d of cardDots; let i = index"
            class="nav-dot"
            [class.active]="i === currentCardIndex"
            [class.small]="isSmallDot(i)"
            (click)="goToCard(i)">
          </span>
        </div>

        <button class="nav-btn" (click)="nextCard()" [disabled]="currentCardIndex === displayedDetalles.length - 1">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </button>
      </div>

      <!-- Botón Nuevo Ítem para modo Tarjeta -->
      <div class="new-btn-fixed" style="padding: 10px 0 0 0; background: transparent;">
        <button class="new-solicitud-btn" (click)="addDetalle()" style="height: 48px; border-radius: 14px;">
          <ion-icon name="add-circle"></ion-icon>
          <span>Nuevo Ítem</span>
        </button>
      </div>

    </div>

    <!-- Botón flotante clásico para modo Lista -->
    <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="viewMode === 'list'">
      <ion-fab-button class="fab-btn premium-fab" (click)="addDetalle()">
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>

  </ion-content>
</div>
